module.exports = __webpack_public_path__ + "static/media/logo.01544859.svg";